import { useReducer } from "react";
import { Store, initialState } from './index';
import reducer from "./reducer";
// its the reducer for the application

const StoreProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    return <Store.Provider value={{ state, dispatch }}>{children}</Store.Provider>;
}

export default StoreProvider;
